import ENV from "../../../services/Environment";
import Requests from "../../../services/Requests";

const baseUrlDownload = `${ENV.base_url}/api/v1/ai_animation/download/`;

/**
 * Triggers a file download in the browser from the download endpoint.
 * (Uses Requests directly to avoid a circular import with AnimationService,
 * which imports this module for the DOM helpers.)
 * @param {string} videoId
 * @param {string} jwtToken
 * @param {object} userData
 * @param {string} [filename]
 * @returns {Promise<void>}
 */
export async function downloadAnimationToDisk(
  videoId,
  jwtToken,
  userData,
  filename
) {
  const result = await Requests.getRequest(
    `${baseUrlDownload}${videoId}`,
    jwtToken,
    userData
  );
  if (!result.ok) {
    throw new Error("Unable to download animation video");
  }
  const blob = await result.blob();
  const url = URL.createObjectURL(blob);
  const downloadLink = document.createElement("a");
  downloadLink.href = url;
  downloadLink.download = filename || "animation.mp4";
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
  URL.revokeObjectURL(url);
}

/**
 * Copies the best-known prompt for an animation to the clipboard and alerts on success.
 * @param {object|null|undefined} selectedAnimation
 */
export function copyAnimationPromptToClipboard(selectedAnimation) {
  if (!selectedAnimation) return;
  const prompt =
    selectedAnimation.revisedPrompt || selectedAnimation.promptUsed;
  if (!prompt) return;
  navigator.clipboard
    .writeText(prompt)
    .then(() => {
      alert("Prompt copied to clipboard");
    })
    .catch((err) => {
      console.error("Failed to copy prompt: ", err);
    });
}
